// extracted by mini-css-extract-plugin
export var addressFields = "_p4-0";
export var animationContainer = "_p4-1";
export var footer = "_p4-2";
export var lineItems = "_p4-3";
export var modalContent = "_p4-4";
export var orderName = "_p4-5";
export var strong = "_p4-6";
export var warning = "_p4-7";